import styles from "../../../LoanRequestPage.module.scss";
import { AttachmentIcon, DownloadIcon } from "../../../../../../assets/icons";
import { OrderType } from "../../../../../../model/orders/orders";

type Props = {
	orderDetails: OrderType;
};

const IdentityTab = ({ orderDetails }: Props) => {
	const { customer } = orderDetails;

	const imgUrl = (customer?.ninVerificationDetails?.photo ?? customer?.internationalPassportVerificationDetails?.photo) ?? "";
	const nin_or_pasport_firstname = (customer?.ninVerificationDetails?.firstName ?? customer?.internationalPassportVerificationDetails?.firstName) ?? "";
	const nin_or_passport_middlename = (customer?.ninVerificationDetails?.middleName ?? customer?.internationalPassportVerificationDetails?.middleName) ?? "";
	const nin_or_pasport_lastname = (customer?.ninVerificationDetails?.surname ?? customer?.internationalPassportVerificationDetails?.lastName) ?? "";
	
	const handleDownload = async (url: string) => {
		try {
			const response = await fetch(url);
			const blob = await response.blob();
			const blobUrl = URL.createObjectURL(blob);

			const link = document.createElement("a");
			link.href = blobUrl;
			link.download = "image_name";
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		} catch (error) {
			window.open(url, "_blank");
		}
	};

	return (
		<section className={styles.detailsTabWrapper}>
			<div className={styles.detailsContent}>
				<div className={styles.item}>
					<div className={styles.label}>Name Submitted</div>
					<div className={styles.value}>
						{customer.firstName} {customer.lastName}
					</div>
				</div>
				<div className={styles.item}>
					<div className={styles.label}>NIN / International Passport Name</div>
					<div className={styles.value}>
						{nin_or_pasport_firstname} {nin_or_passport_middlename} {nin_or_pasport_lastname}
					</div>
				</div>
				<div className={styles.item}>
					<div className={styles.label}>BVN Name</div>
					<div className={styles.value}>
						{!(customer?.bvnVerifyDetails?.firstName && customer?.bvnVerifyDetails?.lastName && customer?.bvnVerifyDetails?.middleName) ? (
							"/"
						) : (
							<>
								{customer?.bvnVerifyDetails?.firstName} {customer?.bvnVerifyDetails?.middleName} {customer?.bvnVerifyDetails?.lastName}
							</>
						)}
					</div>
				</div>
				<div className={styles.item}>
					<div className={styles.label}>Account Number</div>
					<div className={styles.value}>/</div>
				</div>
				<div className={styles.item}>
					<div className={styles.label}>Uploaded Image</div>
					<div className={styles.value}>
						{customer?.photoUrl ? (
							<div
								className={styles.attachment}
								onClick={() => {
									window.open(customer.photoUrl, "_blank");
								}}
							>
								<AttachmentIcon /> View attachment
							</div>
						) : (
							"/"
						)}
					</div>
				</div>
				<div className={styles.item}>
					<div className={styles.label}>Mobile Number</div>
					<div className={styles.value}>{customer.phoneNumber}</div>
				</div>
				<div className={styles.item}>
					<div className={styles.label}>Email Address</div>
					<div className={styles.value}>{customer.email} </div>
				</div>
			</div>
			<div className={styles.imageWrapper}>
				<h3>NIN/ INTERNATIONAL PASSPORT IMAGE</h3>
				{imgUrl ? (
					<div className={styles.image}>
						<div className={styles.download} onClick={() => handleDownload(imgUrl)}>
							<DownloadIcon />
						</div>
						<img src={imgUrl} alt="identity" />
					</div>
				) : (
					<div className={styles.imagePlaceHolder}>No image uploaded</div>
				)}
			</div>
		</section>
	);
};

export default IdentityTab;
